export default __webpack_public_path__ + "3e94423f6015470ad56f192cca91642e.svg";